import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "availability-reminder" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loggedIn)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.subscribeMe)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_checkbox, {
                  modelValue: _ctx.subscribeMe,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subscribeMe) = $event)),
                  name: "remindMe",
                  type: "checkbox",
                  label: _ctx.$t('product.reminder.availability.notSubscribed'),
                  onChange: _ctx.onChange
                }, null, 8 /* PROPS */, ["modelValue", "label", "onChange"])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "availability-reminder__success",
                innerHTML: _ctx.$t('product.reminder.availability.subscribed')
              }, null, 8 /* PROPS */, _hoisted_3))
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_checkbox, {
            name: "remindMeGuest",
            type: "checkbox",
            label: _ctx.$t('product.reminder.availability.notSubscribed'),
            onChange: _ctx.onChangeGuest
          }, null, 8 /* PROPS */, ["label", "onChange"]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          (_ctx.subscribeMeGuest)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "availability-reminder__info",
                innerHTML: _ctx.$t('product.reminder.availability.guest.notSubscribed'),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logMeIn && _ctx.logMeIn(...args)))
              }, null, 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}